import { Card, Typography } from 'antd';
import clx from 'classnames';
import type React from 'react';
import { down } from 'styled-breakpoints';
import styled from 'styled-components';

const { Title, Text } = Typography;

const StyledLoginCard = styled(Card)`
  width: 550px;
  ${down('md')} {
    min-width: 450px;
  }
  ${down('sm')} {
    min-width: unset;
    width: calc(100vw - 40px);
    > .ant-card-body {
      padding: 24px 12px;
    }
  }
  &.full-widht {
    width: 100%;
    ${down('md')} {
      min-width: unset;
    }
    ${down('sm')} {
      min-width: unset;
      width: calc(100vw - 40px);
      margin: auto;
    }
  }
`;

const CardTitle = styled.div`
  text-align: center;
  margin-bottom: 3em;
  margin-top: 1em;
`;

interface LoginCardProps {
  title: React.ReactNode;
  subTitle?: React.ReactNode;
  children?: React.ReactNode;
  fullWidth?: boolean;
}

/**
 * Card stilizzata per le fasi di login
 */
export function LoginCard(props: LoginCardProps) {
  const { title, subTitle, children, fullWidth } = props;

  return (
    <StyledLoginCard
      bordered={false}
      className={clx({ 'full-widht': fullWidth })}
    >
      <CardTitle>
        {title && <Title>{title}</Title>}
        <Text type="secondary">{subTitle}</Text>
      </CardTitle>
      {children}
    </StyledLoginCard>
  );
}
